import React from "react";

import FormResume  from "./components/FormResume";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      width:'90%'
  }
  },

}))

export default function Index() {

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <FormResume />
    </div>
  )
}
